import { useFormikContext } from 'formik';
import React from 'react';
import styled from 'styled-components';

import FormError from './FormError';
import Required from './Required';

const CheckboxAndRadioGroup = (props) => {
  const formikContext = useFormikContext();
  const { name, required, label, children } = props;
  const { errors, touched } = formikContext;

  const error = errors[name];
  const touch = touched[name];

  return (
    <CheckboxAndRadioGroupWrapper>
      <StyledLabel>
        {label} <Required required={required} />
      </StyledLabel>
      {children}
      <FormError touch={touch} error={error} />
    </CheckboxAndRadioGroupWrapper>
  );
};

const CheckboxAndRadioGroupWrapper = styled.fieldset`
  margin-bottom: 25px;
  label {
    margin-bottom: 5px;
  }
`;

const StyledLabel = styled.legend`
  color: var(--blue-dark);
  margin-bottom: 10px;
`;

export default CheckboxAndRadioGroup;
